import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosClient from 'libs/axios/axios';

// TODO : 배열로 변경 필요
const deleteAttendee = async (idList: number[]) => {
  const { data } = await axiosClient.post('/attendee/delete', {
    id_list: idList,
  });

  return data;
};

const useDeleteAttendeeQuery = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteAttendee, {
    onSuccess: () => {
      // ['participant', 'attendeeList'] 로 시작하는 쿼리 모두 무효화
      queryClient.invalidateQueries(['participant', 'attendeeList']);
    },
    onError: (error) => {
      alert('삭제 실패. 다시 한 번 시도해주세요');
      console.error('delete attendee error', error);
    },
  });
};

export default useDeleteAttendeeQuery;
